import React from "react";
import { adminApi as api } from "../../../util/api";
import { snakifyKeys } from "../../../util/helpers";
import { ImportModal } from "../../components/ImportModal";

export const ImportPortalMessageModal = ({ benefitManagementPortalId, onImport, ...rest }) => {
  const handleImport = async (values) => {
    const params = {
      benefitManagementPortalId: benefitManagementPortalId,
      file: {
        bytes: values.file,
      },
    };

    const res = await api.post(`/admin/portal_messages/import.json`, snakifyKeys(params));

    if (onImport) {
      onImport(res.data?.meta?.message);
    }
  };

  return (
    <ImportModal
      buttonProps={rest}
      onImport={handleImport}
      title="Import Portal Messages..."
      exampleDownloadPath="/admin/portal_messages/example"
    ></ImportModal>
  );
};
